import EditLeaveLog from './EditLeaveLog';

export default EditLeaveLog;
